export function formatRangeDate(dates) {
    return `Du ${getDate8AsInt(dates[0])} au ${getDate8AsInt(dates[1])}`
}

export function getDate8AsInt(dateInt8) {
    const year = dateInt8.toString().substring(0, 4);
    const month = dateInt8.toString().substring(4, 6);
    const day = dateInt8.toString().substring(6, 8);
    return `${day}/${month}/${year}`;
}

export function getDateAsInt8(date) {
    const year = new Intl.DateTimeFormat('fr', { year: 'numeric' }).format(date);
    const month = new Intl.DateTimeFormat('fr', { month: '2-digit' }).format(date);
    const day = new Intl.DateTimeFormat('fr', { day: '2-digit' }).format(date);
    return `${year}${month}${day}`;
}

export function getDate8AsDateObj(dateInt8) {
    if(!dateInt8) return null;
    const year = dateInt8.toString().substring(0, 4);
    const month = dateInt8.toString().substring(4, 6);
    const day = dateInt8.toString().substring(6, 8);
    const date = new Date(year, month - 1, day);
    return date;
}

export function formatFromToPrice(price) {
    return `À partir de ${formatPrice(price)}`;
}

export function formatPrice(price) {
    return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(price / 100)
}

export function colorsArrayToLinearGradient(colors){
    return `linear-gradient(to bottom, ${colorJoinForGradient(colors)})`;
}

function colorJoinForGradient(colors) {
    const grad = [];
    colors.forEach((c, i) => {
        grad.push(`${c} ${(100 / colors.length) * i}% ${(100 / colors.length) * (i + 1)}%`);
    })
    return grad.join(',');
}


function getAllInputNames(){
    const inputs = document.querySelectorAll('.cwt-form input');
    const selects = document.querySelectorAll('.cwt-form select');
    const inputsAndSelects = [...inputs, ...selects];
    const names = inputsAndSelects.reduce((acc, inp) => { return (acc.includes(inp.name)) ? acc :  [...acc, inp.name] }, []);
    return names;
}